import { InformationPopupComponent, InformationPopupType } from "../../components/information-popup.component";
import { ObjectHelpers } from "../../helpers/object-helpers";
import { TradeOrderMessageHelpers } from "../../helpers/trade-order-message-helpers";
import { IChartContainer } from "../base/chart-container.interface";
import { ChartSettingsPopupModel } from "../chart-style/chart-settings-popup.model";

export enum TradeOrderType {
    Stop = 'Stop',
    Limit = 'Limit',
    Market = 'Market',
}

export enum TradeInForceType {
    Day = 'Day',
    Week = 'Week',
    DayFillPrePost = 'DayFillPrePost',
    GTC = 'GTC',
    GTCFillPrePost = 'GTCFillPrePost'
}

export enum QuoteType {
    Shares = 'Shares',
    Dollars = 'Dollars'
}

export enum TradeOrderSource {
    unknown,
    /**
     * AI advanced exit (server side)
     */
    ai_exit,
    execution_panel,
    /**
    * From an alert strategy
    */
    auto,
    /**
    * From right click, trade menu
    */
    trade_menu,
    /**
    * From cancel button on positions grid
    */
    button_cancel,
    /**
    * From Limit Out button on positions grid
    */
    button_limit_out,
    stop_exit, button_flatten, button_half, button_reverse, button_double, add_stop, add_target, add_timestop, reduce_risk, profit_save, button_custom,
    /**
    * From a holly strategy, RiskOn
    */
    holly_risk_on,
    /**
    * From a holly strategy, RiskOff
    */
    holly_risk_off,
    /**
    * From a holly strategy, FullRisk
    */
    holly_full_risk,
    /**
    * From a chart, currently only in experimental use by Dave Mabe
    */
    chart,
    /**
    * From positions order entry panel
    */
    order_entry,
    /**
    * From broker_PriceTick method  
    */
    custom_row_data,
    /**
    * Trades Submitted via the Money Machine  
    */
    money_machine,
    /**
    * Trades Submitted from charts, on advanced oep panel.
    */
    chart_advanced_oep
}

export class TradeModel {
    public isBuy = false;
    public isFromOEP = false;
    public autoSend = false;
    public defaultPrice = 0;
    public price = 0;
    public quoteQuantity = 1000;
    public tif = TradeInForceType.Day;
    public orderType = TradeOrderType.Limit;
    public quoteType = QuoteType.Shares;
    public account = '';
    public accountLabel = '';
    public ocaGroup = '';
    public source: TradeOrderSource | null = null;

    public defaultTIF = TradeInForceType.Day;
    public defaultOrderType = TradeOrderType.Market;
    
    public defaultQuoteType = QuoteType.Shares;

    constructor(data?: any) {
        if (data) ObjectHelpers.setPropertiesAndFunctions(data, this, true);
    }

    public submitTrade(base: IChartContainer, submitCallback: Function, cancelCallback: Function) {
        const popup = base.getComponentsByType(InformationPopupComponent)[0] as InformationPopupComponent;
        let chartSettingsPopupModel = base.tiChartSeries?.chartStyleSettings?.chartSettingsPopupModel;
        if (!chartSettingsPopupModel) {
            chartSettingsPopupModel = new ChartSettingsPopupModel();
        }

        if (popup && chartSettingsPopupModel.displayOrderConfirmationPopup) {
            const message = TradeOrderMessageHelpers.getMessage(
                this.isBuy,
                this.quoteType,
                this.orderType,
                this.quoteQuantity,
                this.tif,
                base.tiChartSeries.symbol,
                this.price,
                this.account);
            popup.show(message.title, message.message, (dontShowMessage: boolean) => {
                chartSettingsPopupModel.displayOrderConfirmationPopup = !dontShowMessage;
                base.chartService.requestSaveChartSettingsPopupModel(chartSettingsPopupModel);

                this.requestTrade(base);
                submitCallback();
            }, InformationPopupType.TradeConfirmation, () => {
                cancelCallback();
            });
        } else {
            this.requestTrade(base);
            submitCallback();
        }
    }

    public submitTradeCustomConfirmation(base: IChartContainer, showConfirmation: boolean, showCheckbox: boolean, submitCallback: Function, cancelCallback: Function) {
        const popup = base.getComponentsByType(InformationPopupComponent)[0] as InformationPopupComponent;
        let chartSettingsPopupModel = base.tiChartSeries?.chartStyleSettings?.chartSettingsPopupModel;
        if (!chartSettingsPopupModel) {
            chartSettingsPopupModel = new ChartSettingsPopupModel();
        }

        if (popup && showConfirmation) {
            const message = TradeOrderMessageHelpers.getMessage(
                this.isBuy,
                this.quoteType,
                this.orderType,
                this.quoteQuantity,
                this.tif,
                base.tiChartSeries.symbol,
                this.price,
                this.account);
            popup.show(message.title, message.message, (dontShowMessage: boolean) => {
                chartSettingsPopupModel.displayOrderConfirmationPopup = !dontShowMessage;
                base.chartService.requestSaveChartSettingsPopupModel(chartSettingsPopupModel);

                this.requestTrade(base);
                submitCallback();
            }, showCheckbox ? InformationPopupType.TradeConfirmation : InformationPopupType.Normal, () => {
                cancelCallback();
            });
        } else {
            this.requestTrade(base);
            submitCallback();
        }
    }

    private requestTrade(base: IChartContainer) {
        const model = ObjectHelpers.copy(this);
        base.chartService.requestManualTrade(model);
    }
}